import Swal from 'sweetalert2';

export type TaxAuthorityLinkSwalAction = 'link' | 'issue_without' | 'dismiss';

/**
 * Popup when issuing with "send to tax authority" while the company is not linked to ITA.
 */
export function openTaxAuthorityLinkSwal(curentLang: string): Promise<TaxAuthorityLinkSwalAction> {
  const isAr = curentLang === 'ar';
  const isHe = curentLang === 'he';
  const isRtl = isAr || isHe;
  const dir = isRtl ? 'rtl' : 'ltr';

  const title = isAr
    ? 'ربط مع مصلحة الضرائب'
    : isHe
      ? 'חיבור לרשות המסים'
      : 'Connect to Tax Authority';

  const text = isAr
    ? 'يجب إتمام الربط مع مصلحة الضرائب قبل إرسال الفواتير الإلكترونية والحصول على رقم تخصيص.'
    : isHe
      ? 'יש להשלים את החיבור לרשות המסים לפני שליחת חשבוניות דיגיטליות וקבלת מספר הקצאה.'
      : 'Complete the connection to the Tax Authority before sending digital invoices and receiving an allocation number.';

  const linkLabel = isAr
    ? 'ربط مع مصلحة الضرائب'
    : isHe
      ? 'התחבר לרשות המסים'
      : 'Connect to Tax Authority';

  const issueWithoutLabel = isAr
    ? 'إصدار بدون رقم تخصيص'
    : isHe
      ? 'הפק ללא מספר הקצאה'
      : 'Issue without allocation number';

  return Swal.fire({
    title: '',
    html: `
      <div class="swal-tax-link" dir="${dir}">
        <div class="swal-tax-link__hero" aria-hidden="true">
          <span class="swal-tax-link__hero-icon"><i class="fa fa-link"></i></span>
        </div>
        <h2 class="swal-tax-link__heading">${title}</h2>
        <p class="swal-tax-link__text">${text}</p>
      </div>
    `,
    showConfirmButton: true,
    showDenyButton: true,
    showCloseButton: true,
    focusConfirm: false,
    confirmButtonText: linkLabel,
    denyButtonText: issueWithoutLabel,
    confirmButtonColor: '#E62E2D',
    denyButtonColor: '#64748b',
    reverseButtons: isRtl,
    width: 'min(100%, 28rem)',
    padding: 0,
    customClass: {
      popup: `swal-tax-link-popup${isRtl ? ' swal-tax-link-popup--rtl' : ''}`,
      htmlContainer: 'swal-tax-link-html',
      actions: 'swal-tax-link-actions',
      confirmButton: 'swal-tax-link-btn-link',
      denyButton: 'swal-tax-link-btn-issue',
      closeButton: 'swal-tax-link-close',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      return 'link' as const;
    }
    if (result.isDenied) {
      return 'issue_without' as const;
    }
    return 'dismiss' as const;
  });
}
